import { Component } from '@angular/core';

@Component({
  selector: 'app-conteudos',
  templateUrl: './conteudos.component.html',
  styleUrls: ['./conteudos.component.scss']
})
export class ConteudosComponent { }
